import React from "react";
import PopUp from "../../PopUp/Loadable";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";

export const contentStyle = {
    background: "#fff",
    top: "50%",
    left: "50%",
    right: "",
    bottom: "",
    transform: "translate(-50%,-50%)",
    position: "absolute",
    padding: "0",
    border: "",
    overflow: "",
    borderRadius: "",
    zIndex: "10",
    minHeight: "140px",
    outline: "none",
    WebkitTapHighlightColor: "transparent",
    width: "25%",
};

export const overlayStyle = {
    background: "rgba(0,0,0,0.6)",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "9",
    WebkitTapHighlightColor: "transparent",
};

interface Props {
    closeHandle?: () => void;
    onAfterClose?: () => void;
    show: boolean;
    enableCross: boolean;
    enableEscape?: boolean;
    popUpName?: string;
}
const UserImagePopUpWrapper: React.FC<Props> = ({
    children,
    closeHandle,
    show,
    enableCross,
    enableEscape = true,
    popUpName = "userImageErrorLayer",
    onAfterClose,
}) => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const isLoading = useSelector((state: RootStore) => state.layout.isLoading);
    const style = {
        content: {
            ...contentStyle,
            width: isMobile ? "92%" : "28%",
        },
        overlay: overlayStyle,
    };
    return (
        <>
            <PopUp
                popUpName={popUpName}
                isOpen={show}
                style={style}
                shouldCloseOnOverlayClick={false}
                showHeader={true}
                crossEnabledForDesktop={enableCross ? true : false}
                showHeading={false}
                closeHandle={isLoading ? undefined : closeHandle}
                enableEscape={isLoading ? false : enableEscape}
                preventDefaultBack={isLoading ? true : false}
                onAfterClose={onAfterClose}
            >
                {children}
            </PopUp>
        </>
    );
};

export default UserImagePopUpWrapper;
